var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    `badge badge-${_vm.type} badge-size--${_vm.size}`,
    {
      'is-plain': _vm.plain,
    }
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }